import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClose: '&',
        onUpdate: '&',
        competence: '<'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2>{{ 'user.Edit general data' | translate }}</h2>
        </div>
        <form ng-submit="vm.save()" class="form">
            <div class="modal-body">
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.name">
                        <label class="label">{{ 'user.Competence name' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.name" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </form-wrapper>
            </div>
            <div class="modal-footer" >
                    <ul class="actions01">
                        <li class="primary">
                            <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                        </li>
                        <li>
                            <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button>
                        </li>
                    </ul>
                </div>
        </form>
    `
})
export default class {
    constructor (FormFactory) {
        this.FormFactory = FormFactory;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.competence);
    }

    save () {
        return this.form.save().then((competence) => {
            return this.onUpdate({ updatedCompetence: competence });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/competence/competence/edit/index.js